import { type ReactNode, memo } from 'react';

import { GlobalErrorPage } from './global-error';
import { SentryErrorBoundary } from './sentry-error-boundary';

type Props = {
  children: ReactNode;
};

export const MainErrorBoundary = memo((props: Props) => {
  return (
    <SentryErrorBoundary
      componentId="main-error-boundary"
      renderError={({ sentryEventId }) => {
        return <GlobalErrorPage sentryEventId={sentryEventId || undefined} />;
      }}
    >
      {props.children}
    </SentryErrorBoundary>
  );
});
